module.exports = __webpack_public_path__ + "static/media/after-service-img.16d9d525.png";